import { Link } from "react-router-dom";
import { useState } from "react";
import "./LoginV5.css";

export default function LoginV5(): JSX.Element {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  return (
    <div className="hy-page lvg5">
      <Link to="/" className="lvg5-brand">
        <span className="lvg5-brand-glyph"></span> SubsWall
      </Link>

      <div className="lvg5-shell">
        <div className="lvg5-card hy-card">
          {!sent ? (
            <>
              <span className="hy-sticker">claim your wall</span>
              <h1 className="hy-display lvg5-h1">Welcome back.</h1>
              <p className="hy-lead lvg5-lead">
                We'll send you a one-time sign-in link. No passwords.
              </p>

              <form onSubmit={(e) => { e.preventDefault(); if (email) setSent(true); }}>
                <label className="lvg5-field">
                  <span className="lvg5-label">Email</span>
                  <input
                    type="email"
                    autoFocus
                    placeholder="you@channel.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </label>
                <button type="submit" className="hy-btn hy-btn-primary lvg5-cta">
                  Send sign-in link →
                </button>
              </form>

              <div className="lvg5-divider"><span>or</span></div>

              {/* Google OAuth with youtube.readonly already wired — pulls the
                  user's channel handle + thumbnail on first sign-in. */}
              <a
                href="/auth/google/start?return_to=/dashboard"
                className="hy-btn hy-btn-ghost lvg5-oauth lvg5-oauth-live"
              >
                <span>▶</span> Continue with YouTube
              </a>
              {/* Twitch deferred to v2 — YouTube covers the launch audience. */}

              <div className="lvg5-foot">
                By signing in you agree to our <Link to="/terms">Terms</Link>{" "}
                and <Link to="/privacy">Privacy</Link>.
              </div>
            </>
          ) : (
            <>
              <span className="hy-sticker">check your inbox</span>
              <h1 className="hy-display lvg5-h1">Sent to <em>{email}</em></h1>
              <p className="hy-lead lvg5-lead">
                Click the link we just sent.{" "}
                <button type="button" onClick={() => setSent(false)} className="lvg5-resend">
                  Try a different email
                </button>.
              </p>
            </>
          )}
        </div>
        <Link to="/" className="lvg5-back">← Back home</Link>
      </div>
    </div>
  );
}
